<template>
  <main>
    <contact-us-blurb />
    <div class="container-fluid bg-white pt-3">
      <div class="container">
        <food-navbar current="my-favorites" />
      </div>
    </div>
    <div class="container-fluid bg-white pt-5 pb-5">
      <div class="container">
        <div class="page-title-box">
          My Favorites
        </div>

        <div class="page-subheader-box">
          <div class="split">
            <div class="side category">
              Show:
              <a
                class="inline-tab"
                :class="{on: tab == 'foods'}"
                @click="tab = 'foods'"
              >Foods</a>
              <a
                class="inline-tab"
                :class="{on: tab == 'recipes'}"
                @click="tab = 'recipes'"
              >Recipes</a>
            </div>
            <div class="side category">
              <div class="d-flex">
                <input
                  v-model="query"
                  type="search"
                  class="form-control fff-ui"
                  style="padding: 22px 12px !important;"
                  placeholder="Search Foods"
                  autocomplete="off"
                  @keyup.enter="$refs['query-search'].click()"
                >
                <button
                  ref="query-search"
                  class="button"
                  type="submit"
                  @click="$router.push({ name: 'food-search', query: { s: query } })"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="tab=='foods'"
          class="container py-2 px-0"
        >
          <pagination
            v-if="itemData.length>0"
            :params="paginationParams"
            @go-to-page="load_food_items"
          />
          <food-search-list :items="itemData" />
          <pagination
            v-if="itemData.length>0"
            :params="paginationParams"
            @go-to-page="load_food_items"
          />
        </div>
        <div
          v-if="tab=='recipes'"
          class="container-fluid bg-white pt-4 pb-0 px-0"
        >
          <div class="recipe-grid">
            <pagination
              v-if="recipeData.length>0"
              :params="paginationParams"
              @go-to-page="load_recipes"
            />
            <div
              v-for="(recipe, recipe_index) in recipeData"
              class="recipe-item"
            >
              <div :class="['box', recipe.image_url ? 'has-image' : '']">
                <div
                  class="image"
                  :style="{'background-image': 'url(' + recipe.image_url + ')'}"
                  @click="show_recipe_details_modal(recipe_index)"
                >
                  <div
                    v-if="recipe.is_favorited"
                    class="favorited"
                  >
                    <i class="fas fa-heart" />
                  </div>
                  <div
                    class="food-factor-circle"
                    :class="[recipe.food_color.toLowerCase()]"
                  >
                    <auto-fit-text>{{ recipe.food_factor }}</auto-fit-text>
                  </div>
                </div>
                <div class="text">
                  <div
                    class="name"
                    @click="show_recipe_details_modal(recipe_index)"
                  >
                    {{ recipe.name }}
                  </div>
                  <button
                    class="button"
                    @click="updatemodalData(recipe); is_showing_add_meal_modal = true; "
                  >
                    Add to Meal Log
                  </button>
                </div>
              </div>
            </div>
            <pagination
              v-if="recipeData.length>0"
              :params="paginationParams"
              @go-to-page="load_recipes"
            />

            <div v-if="recipeData.length === 0">
              No results to show.
            </div>
          </div>
        </div>

        <!-- Recipe Details Modal -->
        <recipe-details-modal
          v-if="modal_recipe"
          v-show="is_showing_recipe_details_modal"
          :recipe="modal_recipe"
          @close="hide_recipe_details_modal"
          @toggle-favorite="toggle_favorite"
        >
          <template #actions>
            <button
              class="button fluid"
              @click="updatemodalData(modal_recipe); is_showing_add_meal_modal = true; "
            >
              Add to Meal Log
            </button>
          </template>
        </recipe-details-modal>

        <!-- Add Meal Modal -->
        <add-meal-modal
          v-show="is_showing_add_meal_modal"
          :iteminfo="modalData"
          @hide-modal="is_showing_add_meal_modal = false"
        />

        <!-- Upgrade Modal -->
        <upgrade-modal
          v-show="is_showing_upgrade_modal"
          @show-modal="is_showing_upgrade_modal = true"
          @hide-modal="is_showing_upgrade_modal = false"
        />
      </div>
    </div>
  </main>
</template>

<script>
import foodcleaner from '../components/FoodSearchShared';
import RecipeDetailsModal from "../components/RecipeDetailsModal";

export default {
  name: 'MyFavorites',
  components: {
    RecipeDetailsModal,
  },
  data() {
    return {
      tab: 'foods',
      itemData: [],
      recipeData: [],
      is_showing_recipe_details_modal: false,
      is_showing_add_meal_modal: false,
      is_showing_upgrade_modal: false,
      modal_recipe: false,
      modalData: {},
      paginationParams: {
        current_page: 1,
        total_pages: 1
      },
      query: '',
    };
  },
  watch: {
    'tab': function () {
      this.update_data();
    },
  },
  async mounted() {
    await this.load_food_items();
  },
  methods: {
    async load_food_items(page) {
      let foodItemsrequest = await this.$http('/api/fooditems/favorites' + (page ? '?page=' + page : ''), {
        method: "get",
      }).then(response => response.json())
        .then(async function (json) {
          return json;
        });
      let foodItems = foodcleaner.cleanfooditems(foodItemsrequest.data);
      this.itemData = foodItems;
      this.paginationParams = foodItemsrequest.meta;
    },
    async load_recipes(page) {
      let getrecipes = await this.$http('/api/recipe/favorites?recipe_type=mine_and_fff' + (page ? '&page=' + page : ''), {
        method: "get",
      }).then(response => response.json())
        .then(async function (json) {
          return json;
        });
      let recipes = this.process_recipes_for_display(getrecipes.data);
      this.recipeData = recipes;
      this.paginationParams = getrecipes.meta;
    },
    update_data() {
      if (this.tab == 'foods') {
        this.load_food_items();
      } else {
        this.load_recipes();
      }
    },
    updatemodalData(recipeinfo) {
      this.modalData['type'] = 'recipe';
      this.modalData['serving_size'] = recipeinfo.display_single;
      this.modalData['serving_unit'] = recipeinfo.servings_unit;
      this.modalData['food_recipe_id'] = recipeinfo.id;
      this.modalData['meal_name'] = recipeinfo.name;			// To change title in modal
      this.modalData = Object.assign({}, this.modalData, this.modalData);
      // console.log("modaldata");
      // console.log(this.modalData);
    },
    process_recipes_for_display(recipedata) {
      return foodcleaner.process_recipes_for_display(recipedata);
    },
    show_recipe_details_modal(recipe_index) {
      var obj_multi = document.querySelectorAll('.container');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          if (ele.querySelectorAll('.fff-modal').length === 0) {
            ele.classList.add('dialog-no-print');
          }
        }
      }
      var obj_multi = document.querySelectorAll('.container-fluid');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          if (ele.querySelectorAll('.fff-modal').length === 0) {
            ele.classList.add('dialog-no-print');
          }
        }
      }
      this.is_showing_recipe_details_modal = true;
      this.modal_recipe = this.recipeData[recipe_index];
    },
    hide_recipe_details_modal() {
      var obj_multi = document.querySelectorAll('.dialog-no-print');
      for (const key in obj_multi) {
        if (obj_multi.hasOwnProperty.call(obj_multi, key)) {
          const ele = obj_multi[key];
          ele.classList.remove('dialog-no-print');
        }
      }
      this.is_showing_recipe_details_modal = false;
    },
    async toggle_favorite(modal_recipe) {
      // API request here

      if (this.$parent.user.type == 'individual') {

        let updateditem = await this.$http('/api/recipe/favorites', {
          method: "post",
          body: JSON.stringify({
            'food_recipe_id': modal_recipe.id
          }),
        }).then(response => response.json())
          .then(async function (json) {
            return json.data;
          });

        modal_recipe.is_favorited = !modal_recipe.is_favorited;

      } else {
        this.is_showing_upgrade_modal = true;
      }

    },
  }
};
</script>

<style lang="scss" scoped>
/* Override gray background */
.recipe-grid .recipe-item .image {
    background-color: initial;
}

.recipe-item .box .food-factor-circle {
    top: 5%;
    left: 5%;
    width: 90%;
    height: 90%;
    font-size: 1.2rem;
}

/* image_url is present */
$circle-size: 75px;
.recipe-item .box.has-image .food-factor-circle {
    padding-bottom: 0px;
    width: $circle-size;
    height: $circle-size;
    bottom: -10px;
    right: 8px;
    top: auto;
    left: auto;
}

.recipe-item .box.has-image .food-factor-circle {
    font-size: 1.7rem;
    border-width: 4px;
}
</style>
